/**
 * @fileoverview Mixin del Centro de Ayuda con el registro de eventos de uso (tracking).
 * Cada evento arma su propia copia de `data`: no se modifica el objeto que entrega el padre.
 *
 * Requiere la prop `data` y el catálogo (`products`, `productActive`). El usuario no se informa: el backend lo toma
 * del token de sesión.
 * @module mixins/help-center-tracking.mixin
 */

import { trackEvent } from '@/services/help-center.service'
import {
  TRACKING_ACTIONS,
  TRACKING_MODULE_SEARCH,
  TRACKING_ORIGIN_MULTIPLE
} from '@/constants/help-center'

export default {
  methods: {
    /**
     * Envía un evento de uso.
     * @param {string} action - Acción (ver TRACKING_ACTIONS)
     * @param {string} moduleName - Tema, pregunta o 'Busqueda'
     * @param {Object} [data] - Datos del usuario más el contexto del evento
     * @param {string} [origin] - Producto de origen; por defecto el producto activo
     */
    sendTracking (action, moduleName, data, origin = this.productActive) {
      trackEvent({ data, moduleName, origin, action })
    },

    /** @param {string} topicName - Nombre del tema abierto */
    trackTopic (topicName) {
      this.sendTracking(TRACKING_ACTIONS.CLICK_TOPIC, topicName, this.data)
    },

    /** @param {string} question - Texto de la pregunta tocada */
    trackQuestion (question) {
      this.sendTracking(TRACKING_ACTIONS.CLICK_QUESTION, question, Object.assign({}, this.data))
    },

    /** @param {{question: string, link: string}} click - Pregunta activa y texto del link tocado */
    trackLink ({ question, link }) {
      this.sendTracking(TRACKING_ACTIONS.CLICK_LINKS, question, Object.assign({}, this.data, { link }))
    },

    /** @param {string} term - Texto buscado */
    trackSearch (term) {
      const origin = this.products.length === 1 ? this.productActive : TRACKING_ORIGIN_MULTIPLE
      const data = Object.assign({}, this.data, { search: term })
      this.sendTracking(TRACKING_ACTIONS.SEARCH, TRACKING_MODULE_SEARCH, data, origin)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/help-center-tracking.mixin.js